import { memo, useState, useEffect } from 'react';

const Index = (props) => {
  const { errorimg, textvalue, src } = props;

  const [realShowText, setRealShowText] = useState('');

  useEffect(() => {
    if (errorimg === src) {
      setRealShowText(textvalue);
    }
  }, [src, errorimg]);

  return (
    <div className={'relative'}>
      <img
        onError={(e) => {
          setRealShowText(textvalue);
          e.target.src = errorimg;
          e.target.onerror = null;
        }}
        {...props}
      />
      {realShowText && (
        <div
          title={realShowText}
          className={
            'absolute pl-[10px] pr-[10px] text-[#0093E6] font-bold text-[20px] leading-[27px] left-0 top-[50%] translate-y-[-50%]'
          }
        >
          {realShowText.slice(0, 30)}
        </div>
      )}
    </div>
  );
};

export default memo(Index);
